webpackJsonp([16],{

/***/ 1484:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(696);


/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    this.seenEndpoint = null;
    this.isMenuOpen = false;

    this.attributes({
        key: null,
        detachedDropdown: null,
        offCanvasMenuItem: null,
        content: null,
        link: null,
        countContainer: null,
        count: null
    });

    this.after('initialize', function () {
        this.on(document, 'brandContainer.data.asyncMenuData', this.updateMenu);

        this.on('click', {
            link: this.handleMenuOpen
        });

        // Fired by detachedDropdown
        this.on('closed', {
            detachedDropdown: this.handleMenuClose
        });
    });

    this.handleMenuOpen = function () {
        this.isMenuOpen = true;
        this.trigger('brandContainer.ui.asyncMenuSeen', {
            key: this.attr.key,
            endpoint: this.seenEndpoint
        });
    };

    this.handleMenuClose = function () {
        if (this.isMenuOpen) {
            this.updateCount(0);
            this.isMenuOpen = false;
        }
    };

    this.updateMenu = function (e, data) {
        if (this.attr.key !== data.key) {
            return;
        }

        this.select('content').html(data.content);
        this.trigger('uiNeedsTimeUpdate');
        this.updateCount(data.unseenCount);
        this.seenEndpoint = data.seenEndpoint;
    };

    this.updateCount = function (count) {
        var count = Number(count);

        if (count > 0) {
            this.select('count').html(count);
            this.select('countContainer').removeAttr('data-hidden');
            this.select('offCanvasMenuItem').addClass('menu__item__action--has-pill');
        } else {
            this.select('countContainer').fadeOut(200, function () {
                this.select('count').html(count);
                this.select('countContainer').attr('data-hidden', true);
                this.select('offCanvasMenuItem').removeClass('menu__item__action--has-pill');
            }.bind(this));
        }
    };
};

;

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _brandContainer = __webpack_require__(787);

var _brandContainer2 = _interopRequireDefault(_brandContainer);

__webpack_require__(94);

__webpack_require__(833);

__webpack_require__(128);

__webpack_require__(774);

__webpack_require__(89);

__webpack_require__(339);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Initialise asimov-media-query-label outside dom ready check below. It has its own check and we want
// this to fire early on.
(0, _jquery2.default)(document).mediaQueryLabel();

(0, _jquery2.default)(function () {
    // activate relative date stamps
    (0, _jquery2.default)('span.gmttime').dateTime();

    (0, _jquery2.default)(document).on('uiNeedsTimeUpdate', function (e, data) {
        (0, _jquery2.default)('span.gmttime').dateTime();
    });

    (0, _brandContainer2.default)();

    // activate asimov modals
    (0, _jquery2.default)('[data-modal-name]').modal();

    // activate asimov tooltips
    (0, _jquery2.default)('[data-tooltip]').tooltip();

    // automatically add CSRF tokens to ajax calls
    var token = (0, _jquery2.default)('meta[name="csrf-token"]').attr('content');

    (0, _jquery2.default)(document).ajaxSend(function (elm, xhr, s) {
        if (token && (s.type === 'POST' || s.type === 'DELETE' || s.type === 'PUT')) {
            xhr.setRequestHeader('X-Csrf-Token', token);
        }
    });
});

/***/ }),

/***/ 774:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _asimovCore = __webpack_require__(128);

var _asimovCore2 = _interopRequireDefault(_asimovCore);

var _mediaQueryLabel = __webpack_require__(775);

var _mediaQueryLabel2 = _interopRequireDefault(_mediaQueryLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pluginName = 'mediaQueryLabel',
    defaults = {};

function build(options, elem) {
    var obj = new _mediaQueryLabel2.default().init(options, elem);

    // Public API

    return {
        is: function is(breakpoint) {
            return obj.is(breakpoint);
        },
        get: function get() {
            return obj.get();
        }
    };
}

// Plugin definition
//
_jquery2.default.fn[pluginName] = function (options) {
    return this.each(function () {
        if (!_jquery2.default.data(this, pluginName)) {
            var opts = _asimovCore2.default.mergeElementData((0, _jquery2.default)(this), pluginName, _jquery2.default.extend(true, {}, defaults, options));

            _jquery2.default.data(this, pluginName, build(opts, this));
        }
    });
};

/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _onmediaquery = __webpack_require__(776);

var _onmediaquery2 = _interopRequireDefault(_onmediaquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaQueryLabel = function MediaQueryLabel() {};

MediaQueryLabel.prototype.init = function (options, elem) {
    this.elem = elem;
    this.$elem = (0, _jquery2.default)(elem);

    this.options = options;

    this._bindEvents();

    return this;
};

MediaQueryLabel.prototype.is = function (breakpoint) {
    return this.get() === breakpoint;
};

MediaQueryLabel.prototype.get = function () {
    return (0, _jquery2.default)('html').attr('data-media-query-breakpoint');
};

MediaQueryLabel.prototype._bindEvents = function () {
    // Add queryable DOM property
    (0, _jquery2.default)(document).on('media-query:match', function (e, data) {
        if ((0, _jquery2.default)('html').length) {
            (0, _jquery2.default)('html').attr('data-media-query-breakpoint', data);
        }
    });

    (0, _jquery2.default)(document).ready(function () {
        _onmediaquery2.default.init([{
            context: '*',
            match: function match(breakpoint) {
                (0, _jquery2.default)(document).trigger('media-query:match', breakpoint);
            },
            unmatch: function unmatch(breakpoint) {
                (0, _jquery2.default)(document).trigger('media-query:unmatch', breakpoint);
            }
        }]);
    });
};

exports.default = MediaQueryLabel;

/***/ }),

/***/ 776:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * onMediaQuery
 * http://springload.co.nz/love-the-web/
 *
 * Copyright 2012, Springload
 * Released under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Date: Fri 24 October, 2012
 */

var mq = {};

/**
 * Initialises the MQ object and sets the initial media query callbacks
 * @returns Void(0)
 */
mq.init = function (query_array) {

    // Container for all callbacks registered with the plugin
    this.callbacks = [];
    this.context = ''; //current active query
    this.new_context = ''; //current active query to be read inside callbacks, as this.context won't be set when they're called!

    if (typeof query_array !== 'undefined') {
        for (var i = 0; i < query_array.length; i++) {
            var r = this.addQuery(query_array[i]);
        }
    }

    // Add a listener to the window.resize event, pass mq/self as the scope.
    this.addEvent(window, 'resize', mq.listenForChange, mq);

    // Figure out which query is active on load.
    this.listenForChange();
};

/**
 * Binds to the window.onResize and checks for media query changes
 * @returns Void(0)
 */
mq.listenForChange = function () {
    var query_string, properties;

    // Get the value of html { font-family } from the element style.
    if (document.documentElement.currentStyle) {
        query_string = document.documentElement.currentStyle["fontFamily"];
    }

    if (window.getComputedStyle) {
        properties = window.getComputedStyle(document.body, ':after');
        if ('getCSSPropertyValue' in properties) query_string = properties.getCSSPropertyValue("content").cssText;else query_string = properties.getPropertyValue("content");
        query_string.replace(/^("+)|("+)$/g, '');
    }

    // No support for CSS enumeration? Return and avoid errors.
    if (query_string === null) return;

    // Android browsers place a "," after an item in the font family list.
    // Most browsers either single or double quote the string.
    query_string = query_string.replace(/['",]/g, '');

    if (query_string !== this.context) {
        this.new_context = query_string;
        this.triggerCallbacks(this.context, 'unmatch');
        this.triggerCallbacks(this.new_context, 'match');
    }

    this.context = this.new_context;
};

/**
 * Attach a new query to test.
 * @param query_object {
 *     context: ['some_media_query','some_other_media_query'],
 *     call_for_each_context: true,
 *     callback: function() {
 *         //something awesome
 *     }
 * }
 * @returns A reference to the query_object that was added
 */
mq.addQuery = function (query_object) {
    if (query_object === null || query_object === undefined) return;

    this.callbacks.push(query_object);

    // If the context is passed as a string, turn it into an array (for unified approach elsewhere in the code)
    if (typeof query_object.context == "string") {
        query_object.context = [query_object.context];
    }

    // See if "call_for_each_context" is set, if not, set a default (for unified approach elsewhere in the code)
    if (typeof query_object.call_for_each_context !== "boolean") {
        query_object.call_for_each_context = true; // Default
    }

    // Fire the added callback if it matches the current context
    if (this.context !== '' && this._inArray(this.context, query_object.context)) {
        query_object.match();
    }

    return this.callbacks[this.callbacks.length - 1];
};

/**
 * Remove a query_object by reference.
 * @returns Void(0)
 */
mq.removeQuery = function (query_object) {
    if (query_object === null || query_object === undefined) return;

    var match = -1;

    while ((match = mq._indexOf(query_object, this.callbacks)) > -1) {
        this.callbacks.splice(match, 1);
    }
};

/**
 * Loop through the stored callbacks and execute
 * the ones that are bound to the current context.
 * @returns Void(0)
 */
mq.triggerCallbacks = function (size, key) {
    var i, callback_function, call_for_each_context;

    for (i = 0; i < this.callbacks.length; i++) {

        // Don't call for each context?
        if (this.callbacks[i].call_for_each_context === false) {
            if (key === 'match' && this._inArray(this.context, this.callbacks[i].context) || key === 'unmatch' && this._inArray(this.new_context, this.callbacks[i].context)) {
                // Was previously called, and we don't want to call it for each context
                continue;
            }
        }

        callback_function = this.callbacks[i][key];
        if (this._inArray(size, this.callbacks[i].context) && callback_function !== undefined) {
            callback_function();
        }

        if (this._inArray('*', this.callbacks[i].context) && callback_function !== undefined) {
            callback_function(size);
        }
    }
};

/**
 * Swiss Army Knife event binding, in lieu of jQuery.
 * @returns Void(0)
 */
mq.addEvent = function (elem, type, eventHandle, eventContext) {
    if (elem === null || elem === undefined) return;
    // If the browser supports event listeners, use them.
    if (elem.addEventListener) {
        elem.addEventListener(type, function () {
            eventHandle.call(eventContext);
        }, false);
    } else if (elem.attachEvent) {
        elem.attachEvent("on" + type, function () {
            eventHandle.call(eventContext);
        });

        // Otherwise, replace the current thing bound to on[whatever]! Consider refactoring.
    } else {
        elem["on" + type] = function () {
            eventHandle.call(eventContext);
        };
    }
};

/**
 * Function to return the mediaquery's previous context
 * @returns String returns the current mediaquery's context
 */
mq.getPreviousContext = function () {
    return this.context;
};

/**
 * Function to return the mediaquery's current context
 * @returns String returns the current mediaquery's context
 */
mq.getContext = function () {
    return this.new_context;
};

/**
 * Internal helper function that checks wether "needle" occurs in "haystack"
 * @param needle Mixed Value to look for in haystack array
 * @param haystack Array Haystack array to search in
 * @returns Boolan True if the needle occurs, false otherwise
 */
mq._inArray = function (needle, haystack) {
    var length = haystack.length;
    for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
    }
    return false;
};

/**
 * IE8 do not supports Array.properties.indexOf
 * copy from jQuery.
 * in lieu of jQuery.
 * @returns int
 */
mq._indexOf = function (elem, arr, i) {
    var len;
    if (arr) {
        if (arr.indexOf) {
            return arr.indexOf(elem, i);
        }

        len = arr.length;
        i = i ? i < 0 ? Math.max(0, len + i) : i : 0;

        for (; i < len; i++) {
            // Skip accessing in sparse arrays
            if (i in arr && arr[i] === elem) {
                return i;
            }
        }
    }

    return -1;
};

// Expose the functions.
exports.default = mq;

/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _asimovCore = __webpack_require__(128);

var _asimovCore2 = _interopRequireDefault(_asimovCore);

var _offCanvas = __webpack_require__(781);

var _offCanvas2 = _interopRequireDefault(_offCanvas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pluginName = 'offCanvas',
    defaults = {
    'name': '',
    'variation': 'left'
};

function build(options, elem) {
    var obj = new _offCanvas2.default().init(options, elem);

    return {
        toggle: function toggle() {
            if (obj.isOpen()) {
                obj.close();
            } else {
                obj.open();
            }

            return this;
        }
    };
}

// Plugin definition

_jquery2.default.fn[pluginName] = function (options) {
    return this.each(function () {
        if (!_jquery2.default.data(this, pluginName)) {
            var opts = _asimovCore2.default.mergeElementData((0, _jquery2.default)(this), 'oc', _jquery2.default.extend(true, {}, defaults, options));

            _jquery2.default.data(this, pluginName, build(opts, this));
        }
    });
};

/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(782);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OffCanvas = function OffCanvas() {};

OffCanvas.prototype.init = function (options, elem) {
    this.elem = elem;
    this.$elem = (0, _jquery2.default)(elem);

    this.options = options;
    this.isActive = false;

    this._bindEvents(this.options, this.$elem);

    return this;
};

OffCanvas.prototype.isOpen = function (name) {
    return this.isActive;
};

OffCanvas.prototype.close = function (name) {
    var that = this,
        $canvas = that._getCanvas(name),
        $content = (0, _jquery2.default)('[data-oc-content=' + name + ']');

    // transitionEnd won't fire for zero second transitions, which we are using
    // for old Safari's and IE. This manually checks for this case, and closes the off-canvas immediately.
    // http://whoknew.dk/transitionend-will-not-fire-with-transition-duration-zero-481.htm

    var durationIsZero = $canvas.css('-webkit-transition-duration') === '0s' || $canvas.css('transition-duration') === '0s';

    if (durationIsZero) {
        that._close($canvas, $content);
    } else {
        $canvas.transitionEnd(function () {
            that._close($canvas, $content);
        });
    }

    (0, _jquery2.default)(document).trigger('oc:change', [$canvas, 'close']);

    $canvas.removeAttr('data-oc-state');
};

OffCanvas.prototype.open = function (name) {
    var that = this,
        $canvas = that._getCanvas(name),
        $content = (0, _jquery2.default)('[data-oc-content=' + name + ']'),
        variation = $content.attr('data-oc-variation');

    // set variation
    $canvas.attr('data-oc-variation', variation);

    // animate
    $canvas.attr('data-oc-state', 'active');
    $content.attr('data-oc-state', 'active');

    // add close trigger
    $canvas.one('click', function (e) {
        if (that._getTriggers(name).filter((0, _jquery2.default)(e.target)).length === 0) {
            that.close(name);
        }
    });

    this.isActive = true;

    (0, _jquery2.default)(document).trigger('oc:change', [$canvas, 'open']);

    return this;
};

OffCanvas.prototype._bindEvents = function (options, $element) {
    var that = this;

    _jquery2.default.each(options.name.split(' '), function (i, name) {
        $element.on('click', '[data-oc-trigger=' + name + ']', function (e) {
            var $canvas = that._getCanvas(name),
                $content = that._getContent(name);

            // cache the variation info
            $content.attr('data-oc-variation', $content.attr('data-oc-variation') || that.options.variation);

            // animation triggers
            if (that.isOpen()) {
                that.close(name);
            } else {
                that.open(name);
            }

            return false;
        });
    });
};

OffCanvas.prototype._getContent = function (name) {
    return (0, _jquery2.default)('[data-oc-canvas=' + name + ']');
};

OffCanvas.prototype._getCanvas = function (name) {
    return (0, _jquery2.default)('[data-oc-canvas~=' + name + ']');
};

OffCanvas.prototype._getTriggers = function (name) {
    return (0, _jquery2.default)('[data-oc-trigger~=' + name + ']');
};

OffCanvas.prototype._close = function ($canvas, $content) {
    $content.removeAttr('data-oc-state');
    $canvas.removeAttr('data-oc-variation');

    this.isActive = false;
};

exports.default = OffCanvas;

/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
// ============================================================

function transitionEnd() {
    var name,
        el = document.createElement('asimov'),
        transEndEventNames = {
        'WebkitTransition': 'webkitTransitionEnd',
        'MozTransition': 'transitionend',
        'OTransition': 'oTransitionEnd otransitionend',
        'transition': 'transitionend'
    };

    for (name in transEndEventNames) {
        if (el.style[name] !== undefined) {
            return {
                end: transEndEventNames[name]
            };
        }
    }
}

_jquery2.default.fn.transitionEnd = function (callback) {
    if (_jquery2.default.support.transition) {
        (0, _jquery2.default)(this).one(_jquery2.default.support.transition.end, callback);
    } else {
        callback.call((0, _jquery2.default)(this));
    }

    return this;
};

(0, _jquery2.default)(function () {
    _jquery2.default.support.transition = transitionEnd();
});

/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(2);
var asimov = __webpack_require__(128).default;
var PromoBar = __webpack_require__(785);

var pluginName = 'promoBar';
var promoBars = {};
var defaults = {
    cookieName: '',
    cookieDays: 1,
    cookiePrefix: '',
    dismissSelector: '[data-promo-bar-dismiss]'
};

function build(options, elem) {

    var obj = new PromoBar().init(options, elem);

    // Public API
    return {

        show: function show() {
            obj.show();
            return this;
        },

        hide: function hide() {
            obj.hide();
            return this;
        }

    };
}

// Plugin definition
$.fn[pluginName] = function (options) {
    return this.each(function () {
        if (!$.data(this, pluginName)) {
            var opts = asimov.mergeElementData($(this), pluginName, $.extend(true, {}, defaults, options));

            $.data(this, pluginName, build(opts, this));
        }
    });
};

/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var set = function set(name, value, days) {
    var date,
        expires = '';

    if (days) {
        date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
};

var get = function get(c_name) {
    var c_start, c_end;

    if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + '=');
        if (c_start !== -1) {
            c_start = c_start + c_name.length + 1;
            c_end = document.cookie.indexOf(';', c_start);
            if (c_end === -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return '';
};

module.exports = {
    set: set,
    get: get
};

/***/ }),

/***/ 785:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(2);
var Cookie = __webpack_require__(784);

var PromoBar = function PromoBar() {};

PromoBar.prototype = {

    init: function init(options, el) {
        this.$el = $(el);

        // Prepare options
        this.options = options;
        this.options.endpoint = this.$el.data('promoBarEndpoint') || null;
        this.options.cookieName = this.$el.data('promoBarName') || '';

        // Setup static or async promo-bar
        if (this.options.endpoint) {
            this.setupAsyncPromoBar();
        } else {
            this.setupStaticPromoBar();
        }
    },

    setupAsyncPromoBar: function setupAsyncPromoBar() {
        this.getMessage();
    },

    setupStaticPromoBar: function setupStaticPromoBar() {
        this.attachEvents();
    },

    getMessage: function getMessage() {
        $.getJSON(this.options.endpoint, this.processMessageResponse.bind(this));
    },

    processMessageResponse: function processMessageResponse(data) {
        if (data.name != null) {
            this.options.cookieName = data.name;
            this.$el.attr('data-promo-bar-name', data.name);
            this.$el.html(data.content);
            this.attachEvents();
            this.show();
        }
    },

    attachEvents: function attachEvents() {
        this.$el.find(this.options.dismissSelector).on('click', function (e) {
            e.preventDefault();
            this.hide();
            this.setSeenCookie();
        }.bind(this));
    },

    show: function show() {
        this.$el.removeAttr('data-hidden');
        if (typeof this.options.onShow == 'function') {
            this.options.onShow(this);
        }
        $(document).trigger('promo-bar-show');
    },

    hide: function hide() {
        this.$el.attr('data-hidden', '');
        if (typeof this.options.onHide == 'function') {
            this.options.onHide(this);
        }
        $(document).trigger('promo-bar-hide');
    },

    setSeenCookie: function setSeenCookie(fast) {
        Cookie.set(this.options.cookieName, 1, this.options.cookieDays);
    }

};

module.exports = PromoBar;

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var role = (0, _jquery2.default)('[data-globalnavui-userrole]').data('globalnavui-userrole') || 'logged-out';
    var dropdowns = [];

    _asyncMenu2.default.attachTo(document, {
        needsInitialData: ['contest-holder', 'designer'].some(function (item) {
            return item === role;
        })
    });

    _messagesMenu2.default.attachTo('[data-globalnavui]', {
        key: 'messages',
        content: '[data-globalnavui-messages]',
        detachedDropdown: '[data-globalnavui-messages-detached-dropdown]',
        offCanvasMenuItem: '[data-globalnavui-messages-off-canvas-menu-item]',
        countContainer: '[data-globalnavui-messages-count-container]',
        link: '[data-globalnavui-messages-link]',
        count: '[data-globalnavui-messagecount]'
    });

    _notificationsMenu2.default.attachTo('[data-globalnavui]', {
        key: 'notifications',
        content: '[data-globalnavui-notifications]',
        detachedDropdown: '[data-globalnavui-notifications-detached-dropdown]',
        offCanvasMenuItem: '[data-globalnavui-notifications-off-canvas-menu-item]',
        link: '[data-globalnavui-notifications-link]',
        countContainer: '[data-globalnavui-notifications-count-container]',
        count: '[data-globalnavui-notificationcount]'
    });

    _loginRedirect2.default.attachTo('[data-globalnavui]');

    _chatStatus2.default.attachTo('[data-globalnavui]');
    _chat2.default.attachTo('[data-globalnavui]');

    (0, _jquery2.default)('[data-oc-name]').offCanvas();

    (0, _jquery2.default)('[data-global-nav-detached-dropdown]').each(function (i, el) {
        dropdowns.push(new _asimovDetachedDropdown2.default((0, _jquery2.default)(el)));
    }.bind(this));

    (0, _jquery2.default)('[data-promo-bar]').promoBar();

    (0, _jquery2.default)('[data-global-nav-tooltip]').tooltip();

    // Update localized times in messages and notifications panes when they are changed
    (0, _jquery2.default)(document).on('brandContainer.ui.notificationsUpdated, brandContainer.ui.messagesUpdated', function () {
        (0, _jquery2.default)(document).trigger('uiNeedsTimeUpdate');
    });

    // Use link elements for interaction instead of clickable spans

    (0, _jquery2.default)('[data-no-link]').on('click', function (e) {
        // Middle click, cmd click, and ctrl click should open
        // links in a new tab as normal.
        if (e.which > 1 || e.metaKey) {
            return true;
        } else {
            e.preventDefault();
        }
    });

    // Init admin controls if available
    if ((0, _jquery2.default)('[data-admin-bar]').length > 0) {
        (0, _jquery2.default)('[data-admin-bar]').detach().prependTo('body');
        _userSwitcher2.default.attachTo('[data-user-switcher]');
        _userSearch2.default.attachTo(document, { 'apiUrl': (0, _jquery2.default)('[data-user-search-form]').attr('action') });
        _userSearch4.default.attachTo('[data-admin-bar] [data-user-search]');
        _adminBar2.default.attachTo('[data-admin-bar]');
        _adminBarToggle2.default.attachTo('[data-admin-bar-toggle]');
        _offsetGlobalNav2.default.attachTo(document.body);
        _bugReporter2.default.attachTo('[data-admin-bar-bug-reporter]');
    }
};

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _adminBarToggle = __webpack_require__(790);

var _adminBarToggle2 = _interopRequireDefault(_adminBarToggle);

var _adminBar = __webpack_require__(791);

var _adminBar2 = _interopRequireDefault(_adminBar);

var _loginRedirect = __webpack_require__(795);

var _loginRedirect2 = _interopRequireDefault(_loginRedirect);

var _asyncMenu = __webpack_require__(788);

var _asyncMenu2 = _interopRequireDefault(_asyncMenu);

var _notificationsMenu = __webpack_require__(797);

var _notificationsMenu2 = _interopRequireDefault(_notificationsMenu);

var _messagesMenu = __webpack_require__(796);

var _messagesMenu2 = _interopRequireDefault(_messagesMenu);

var _offsetGlobalNav = __webpack_require__(798);

var _offsetGlobalNav2 = _interopRequireDefault(_offsetGlobalNav);

var _userSearch = __webpack_require__(789);

var _userSearch2 = _interopRequireDefault(_userSearch);

var _userSearch3 = __webpack_require__(799);

var _userSearch4 = _interopRequireDefault(_userSearch3);

var _userSwitcher = __webpack_require__(800);

var _userSwitcher2 = _interopRequireDefault(_userSwitcher);

var _chatStatus = __webpack_require__(793);

var _chatStatus2 = _interopRequireDefault(_chatStatus);

var _chat = __webpack_require__(794);

var _chat2 = _interopRequireDefault(_chat);

var _bugReporter = __webpack_require__(792);

var _bugReporter2 = _interopRequireDefault(_bugReporter);

var _asimovDetachedDropdown = __webpack_require__(146);

var _asimovDetachedDropdown2 = _interopRequireDefault(_asimovDetachedDropdown);

__webpack_require__(128);

__webpack_require__(780);

__webpack_require__(783);

__webpack_require__(339);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;

/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

function AsyncMenu() {
    this.attributes({
        needsInitialData: false,
        endpoint: '/api/global-nav/v2/notifications-and-messages.json',
        updateEvents: 'vandamme.notification vandamme.notification.seen vandamme.privatemessage.received'
    });

    this.menus = [{
        key: 'messages',
        unseenCount: 'unseenMessageCount',
        seenEndpoint: 'messagesSeenEndpoint'
    }, {
        key: 'notifications',
        unseenCount: 'unseenNotificationCount',
        seenEndpoint: 'notificationsSeenEndpoint'
    }];

    this.after('initialize', function () {
        this.on(document, 'brandContainer.ui.needsAllData', this.fetchData);
        this.on(document, 'brandContainer.ui.asyncMenuSeen', this.handleMenuSeen);

        this.on(document, this.attr.updateEvents, function () {
            this.trigger('brandContainer.ui.needsAllData');
        }.bind(this));

        if (this.attr.needsInitialData) {
            this.trigger('brandContainer.ui.needsAllData');
        }
    });

    this.fetchData = function () {
        // Turns out this never worked in IE9 due to lack of cors support.
        // This appears to fix it, but need to investigate impact
        // See http://stackoverflow.com/questions/10232017/ie9-jquery-ajax-with-cors-returns-access-is-denied/10232313#10232313
        $.support.cors = true;

        $.ajax({
            url: this.attr.endpoint,
            dataType: 'json',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            this.processResponse(data);
        }.bind(this));
    };

    this.processResponse = function (data) {
        this.menus.forEach(function (menu) {
            this.trigger('brandContainer.data.asyncMenuData', {
                key: menu.key,
                content: data[menu.key],
                unseenCount: data[menu.unseenCount],
                seenEndpoint: data[menu.seenEndpoint]
            });
        }.bind(this));
    };

    this.handleMenuSeen = function (e, data) {
        $.ajax({
            url: data.endpoint,
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            }
        });
    };
};

exports.default = (0, _flightjs.component)(AsyncMenu);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 789:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

var xhr = null;

var UserSearch = function UserSearch() {
    this.attributes({
        'apiUrl': null
    });

    this.doSearch = function (e, query) {
        if (xhr) {
            xhr.abort();
        }

        xhr = $.get(this.attr.apiUrl, {
            q: query,
            newMarkup: true
        });

        xhr.done(function (data) {
            this.trigger('brandContainer.data.userSearch', [data]);
        }.bind(this));
    };

    this.after('initialize', function () {
        this.on('brandContainer.ui.requestUserSearch', this.doSearch);
    });
};

exports.default = (0, _flightjs.component)(UserSearch);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 790:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

function AdminBarToggle() {
    this.after('initialize', function () {
        this.on('click', this.triggerToggle);
        this.on(document, 'brandContainer.ui.adminBarShown', this.setActive);
        this.on(document, 'brandContainer.ui.adminBarHidden', this.setInactive);
    });

    this.triggerToggle = function () {
        this.trigger('brandContainer.ui.adminBarToggleRequested');
    };

    this.setActive = function () {
        this.$node.attr('data-active', true);
    };

    this.setInactive = function () {
        this.$node.removeAttr('data-active');
    };
};

exports.default = (0, _flightjs.component)(AdminBarToggle);

/***/ }),

/***/ 791:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

function AdminBar() {

    this.after('initialize', function () {
        this.on(document, 'brandContainer.ui.adminBarToggleRequested', this.toggleAdminBar);
        this.loadState();
    });

    this.showAdminBar = function () {
        this.$node.removeAttr('data-hidden');
        this.saveState();
        this.trigger('brandContainer.ui.adminBarShown', {});
    };

    this.hideAdminBar = function () {
        this.$node.attr('data-hidden', true);
        this.saveState();
        this.trigger('brandContainer.ui.adminBarHidden', {});
    };

    this.toggleAdminBar = function () {
        if (!this.$node.attr('data-hidden')) {
            this.hideAdminBar();
        } else {
            this.showAdminBar();
        }

        this.scrollToTop();
    };

    this.scrollToTop = function () {
        $('body').animate({ scrollTop: 0 }, 'fast');
    };

    this.saveState = function () {
        var state = this.$node.attr('data-hidden');
        if (state) {
            document.cookie = 'admin:bar=hide; path=/';
        } else {
            document.cookie = 'admin:bar=show; path=/';
        }
    };

    this.loadState = function () {
        if (!!~document.cookie.indexOf('admin:bar=hide')) {
            this.hideAdminBar();
        } else {
            this.showAdminBar();
        }
    };
};

exports.default = (0, _flightjs.component)(AdminBar);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 792:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

function BugReporter() {
    this.attributes({
        'cardNameAttr': 'data-bug-report-card-name',
        'listIdAttr': 'data-bug-report-list-id',
        'reportActionTrigger': '[data-bug-report-action]',
        'reportWindowOffsetTop': 370,
        'reportWindowOffsetLeft': 250,
        'reportWindowWidth': 500,
        'reportWindowHeight': 600
    });

    this.after('initialize', function () {
        this.on('click', {
            reportActionTrigger: this.openCreateCardWindow
        });
    });

    this.openCreateCardWindow = function () {
        var listId = this.$node.attr(this.attr.listIdAttr) || '56e8e2aee74a708f2bab8641';
        var cardName = this.$node.attr(this.attr.cardNameAttr) || 'Bug report';
        var reportWindowProps = '';
        var reportWindowName = 'add-trello-card';
        var reportWindowURL = 'https://trello.com/add-card?';

        reportWindowURL += 'source=' + encodeURIComponent(window.location.href);
        reportWindowURL += '&mode=popup';
        reportWindowURL += '&url=' + encodeURIComponent(window.location.href);
        reportWindowURL += '&name=' + encodeURIComponent(cardName);
        reportWindowURL += '&idList=' + listId;

        reportWindowProps += 'width=' + this.attr.reportWindowWidth;
        reportWindowProps += ',height=' + this.attr.reportWindowWidth;
        reportWindowProps += ',left=' + (window.screenX + window.outerWidth / 2 - this.attr.reportWindowOffsetLeft);
        reportWindowProps += ',top=' + (window.screenY + window.outerHeight / 2 - this.attr.reportWindowOffsetTop);

        window.open(reportWindowURL, reportWindowName, reportWindowProps);
    };
};

exports.default = (0, _flightjs.component)(BugReporter);

/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

function ChatStatus() {
    this.attributes({
        'chatAvailableSelector': '[data-chat-available]',
        'chatUnavailableSelector': '[data-chat-unavailable]'
    });

    this.after('initialize', function () {
        this.on(document, 'chatSupportOnline', this.showAvailable);
        this.on(document, 'chatSupportOffline', this.showUnavailable);
    });

    this.showAvailable = function () {
        this.select('chatUnavailableSelector').attr('data-hidden', true);
        this.select('chatAvailableSelector').removeAttr('data-hidden');
    };

    this.showUnavailable = function () {
        this.hideAvailable();
        this.select('chatUnavailableSelector').removeAttr('data-hidden');
    };

    this.hideAvailable = function () {
        this.select('chatAvailableSelector').attr('data-hidden', true);
    };
};

exports.default = (0, _flightjs.component)(ChatStatus);

/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

function ChatFlight() {
    this.defaultAttrs({
        expandChatBoxSelector: '[data-chat-expand]'
    });

    this.expand = function (event) {
        event.preventDefault();
        window.$zopim.livechat.window.show();
    };

    this.show = function (event) {
        event.preventDefault();

        if (window.$zopim.livechat.isChatting()) {
            window.$zopim.livechat.window.show();
        } else {
            window.$zopim.livechat.button.show();
        }
    };

    this.hide = function (event) {
        event.preventDefault();
        window.$zopim.livechat.hideAll();
    };

    this.onZopimLoaded = function () {
        if (this.isZendeskWebWidgetLive()) {
            // All of the codes below are for showing and hiding
            // the chat status links in the global nav
            // Once Zendesk web widget is live we will no longer need
            // chat status links therefore skip everything below.
            return;
        }

        var self = this;

        this.on('click', {
            expandChatBoxSelector: this.expand
        });

        this.on('chatSupportOnline', this.show);
        this.on('chatSupportOffline', this.hide);

        // Zopim don't have the API to allow us to get the assigned department id.
        // __99departmentId is a hack we added in GTM to work around the issue
        var departmentId = $zopim.livechat.__99departmentId;

        if (departmentId) {
            this.setStatusByDepartment(departmentId);
        }

        window.$zopim.livechat.setOnStatus(function (status) {
            // We need to hide the widget when the assigned department is offline
            // Zendesk chat doesn't have that feature at the moment.
            // Issue: https://support.zendesk.com/hc/en-us/requests/1994340
            // Hence the existence of this hack
            if (status === 'online' && self.isDepartmentOnline(departmentId)) {
                self.trigger('chatSupportOnline');
            } else {
                self.trigger('chatSupportOffline');
            }
        });
    };

    this.setStatusByDepartment = function (departmentId) {
        var self = this;

        window.$zopim.livechat.setOnConnected(function () {
            var status;

            if (self.isDepartmentOnline(departmentId)) {
                status = 'online';
            } else {
                status = 'offline';
            }
            window.$zopim.livechat.setStatus(status);
        });
    };

    this.isZendeskWebWidgetLive = function () {
        // zE is loaded externally by GTM
        // See https://tagmanager.google.com/?hl=en#/container/accounts/16298402/containers/709958/workspaces/227/tags/172
        return window.zE;
    };

    this.isDepartmentOnline = function (departmentId) {
        var department = window.$zopim.livechat.departments.getDepartment(departmentId);

        if (department) {
            return department.status === 'online';
        }

        return false;
    };

    this.after('initialize', function () {
        var timeoutInMs = 10000;
        var self = this;
        var zopimChecker;

        zopimChecker = window.setInterval(function () {
            if (window.$zopim) {
                window.$zopim(function () {
                    self.onZopimLoaded();
                });

                window.clearInterval(zopimChecker);
            }
        }, 100);

        window.setTimeout(function () {
            if (zopimChecker) {
                window.clearInterval(zopimChecker);
            }
        }, timeoutInMs);
    });
};

exports.default = (0, _flightjs.component)(ChatFlight);

/***/ }),

/***/ 795:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

function LoginRedirect() {
    this.attributes({
        loginLinkSelector: '[data-globalnavui-loginlink]'
    });
    /**
     * Update the target component of the login url with the current
     * url. This is done on the front-end to improve cacheability.
     */
    this.after('initialize', function () {
        var $loginLink = this.select('loginLinkSelector');
        if ($loginLink.length) {
            var loginHref = $loginLink.attr('href');
            var currentUrl = encodeURIComponent(document.location.href);

            // Replace `return` parameter in direct-to-SSO link
            loginHref = loginHref.replace(/target=([^&]+)/, 'target=' + currentUrl);
            // Replace `from` parameter in simple `/login` link
            loginHref = loginHref.replace(/\bfrom=([^&]+)/, 'from=' + currentUrl);

            $loginLink.attr('href', loginHref);
        }
    });
}

exports.default = (0, _flightjs.component)(LoginRedirect);

/***/ }),

/***/ 796:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flightjs = __webpack_require__(3);

var _asyncMenu = __webpack_require__(571);

var _asyncMenu2 = _interopRequireDefault(_asyncMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _flightjs.component)(_asyncMenu2.default);

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flightjs = __webpack_require__(3);

var _asyncMenu = __webpack_require__(571);

var _asyncMenu2 = _interopRequireDefault(_asyncMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _flightjs.component)(_asyncMenu2.default);

/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

function OffsetGlobalNav() {
    this.attributes({
        'ocWrapper': '[data-globalnavui]',
        'offsetDataAttr': 'data-oc-offset-admin-bar'
    });

    this.after('initialize', function () {
        this.on(document, 'brandContainer.ui.adminBarShown', this.applyOffset);
        this.on(document, 'brandContainer.ui.adminBarHidden', this.removeOffset);
    });

    this.applyOffset = function () {
        this.select('ocWrapper').attr(this.attr.offsetDataAttr, true);
    };

    this.removeOffset = function () {
        this.select('ocWrapper').removeAttr(this.attr.offsetDataAttr);
    };
};

exports.default = (0, _flightjs.component)(OffsetGlobalNav);

/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

function UserSearch() {
    this.lastQuery = null;

    this.attributes({
        'queryInput': 'input[name=q]',
        'searchResults': '[data-user-search-results]',
        'toggleButton': '[data-dropdown-toggle]',
        'searchForm': '[data-user-search-form]',
        'menuTrigger': '[data-user-search-menu-trigger]'
    });

    this.after('initialize', function () {
        this.on('keyup', { searchForm: _flightjs.utils.debounce(this.handleSearch) });
        this.on('submit', { searchForm: this.handleSearch });
        this.on(document, 'brandContainer.data.userSearch', this.showResults);
        this.on('click', {
            toggleButton: this.toggle,
            menuTrigger: this.focusSearch
        });
    });

    this.focusSearch = function (e) {
        setTimeout(function () {
            this.select('queryInput').focus();
        }.bind(this), 100);
    };

    // Triggers the search event, passing the search query
    this.handleSearch = function (e) {
        var query = this.select('queryInput').val();

        e.preventDefault();

        if (e.keyCode === 27) {
            this.select('menuTrigger').click();
        }

        if (!this.lastQuery || this.lastQuery !== query) {
            this.trigger(document, 'brandContainer.ui.requestUserSearch', [query]);
            this.lastQuery = query;
        }
    };

    this.showResults = function (e, data) {
        this.select('searchResults').html(data);
        this.trigger('uiNeedsTimeUpdate');
    };

    this.show = function () {
        this.$node.attr('data-active', '');
        this.select('queryInput').focus();
    };

    this.hide = function () {
        this.$node.removeAttr('data-active');
    };

    this.toggle = function (e) {
        e.preventDefault();
        if (this.$node.is('[data-active]')) {
            this.hide();
        } else {
            this.show();
        }
    };
} //
// Admin bar user search UI component.
//

;

exports.default = (0, _flightjs.component)(UserSearch);

/***/ }),

/***/ 800:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

function UserSwitcher() {

    this.defaultAttrs({
        radioSelector: 'input[type=radio][name=userid]'
    });

    this.after('initialize', function () {
        this.on(this.$node.select('radioSelector'), 'change', this.submitForm);
    });

    this.submitForm = function () {
        var $form = this.$node.closest('form');

        if (!this.$node.find('input[name="from"]').length) {
            $('<input>').attr({
                type: 'hidden',
                name: 'from'
            }).val(this.getFromUrl()).appendTo($form);
        }

        $form.submit();
    };

    this.getFromUrl = function () {
        return window.location.href;
    };
}

exports.default = (0, _flightjs.component)(UserSwitcher);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
// ============================================================

function transitionEnd() {
    var name,
        el = document.createElement('asimov'),
        transEndEventNames = {
        'WebkitTransition': 'webkitTransitionEnd',
        'MozTransition': 'transitionend',
        'OTransition': 'oTransitionEnd otransitionend',
        'transition': 'transitionend'
    };

    for (name in transEndEventNames) {
        if (el.style[name] !== undefined) {
            return {
                end: transEndEventNames[name]
            };
        }
    }
}

_jquery2.default.fn.transitionEnd = function (callback) {
    if (_jquery2.default.support.transition) {
        (0, _jquery2.default)(this).one(_jquery2.default.support.transition.end, callback);
    } else {
        callback.call((0, _jquery2.default)(this));
    }

    return this;
};

(0, _jquery2.default)(function () {
    _jquery2.default.support.transition = transitionEnd();
});

/***/ })

},[1484]);


// WEBPACK FOOTER //
// app/layout-f86983429a0e6acbf242.js